// extracted by mini-css-extract-plugin
export default {"links":"styles_links__NlVMU","copyright":"styles_copyright__doYlw"};